"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
var CollapseEffect = function (_a) {
    var children = _a.children, visibled = _a.visibled, id = _a.id, className = _a.className;
    return ((0, jsx_runtime_1.jsx)(antd_1.Collapse, tslib_1.__assign({ ghost: true, bordered: false, activeKey: visibled ? '1' : undefined, className: className }, { children: (0, jsx_runtime_1.jsx)(antd_1.Collapse.Panel, tslib_1.__assign({ header: '', id: id }, { children: children }), '1') })));
};
exports.default = (0, styled_1.default)(CollapseEffect)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  & .ant-collapse-header {\n    display: none !important;\n  }\n\n  & .ant-collapse-content-box {\n    padding: 0 !important;\n  }\n"], ["\n  & .ant-collapse-header {\n    display: none !important;\n  }\n\n  & .ant-collapse-content-box {\n    padding: 0 !important;\n  }\n"])));
var templateObject_1;
